class CartDiscountCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('.cart-discount-form__input');
    this.button = this.querySelector('.cart-discount-form__button');
    this.form = this.querySelector('form');
    this.button.addEventListener('click', this.applyDiscount.bind(this));
  }

  async applyDiscount(event) {
    event.preventDefault();

    if (!this.input) return;

    const code = this.input.value.trim();
    if (!code) return;

    if (this.button) {
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('loading');
    }

    try {
      const rootUrl = window.Shopify?.routes?.root || '/';

      const updateResponse = await fetch(`${rootUrl}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      });

      if (!updateResponse.ok) {
        throw new Error('Failed to update discount');
      }

      const responseData = await updateResponse.json();

      const discountObj = responseData?.discount_codes?.find(
        d => d.code.toLowerCase() === code.toLowerCase()
      );

      const isApplied = discountObj ? discountObj.applicable === true : false;

      if (!isApplied) {
        this.showError();

        return;
      }

      const sectionResponse = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      const text = await sectionResponse.text();

      const html = new DOMParser().parseFromString(text, 'text/html');
      const sourceHTML = html.querySelector(".cart-drawer").outerHTML;

      const destination = document.querySelector('cart-drawer');

      if (destination) {
        destination.innerHTML = sourceHTML;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true
      }));

    } catch (error) {
      console.error('Error applying discount:', error);
    } finally {
      if (this.button) {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
      }
    }
  }

  showError() {
    if (!this.input) return;

    this.input.classList.add('is-invalid');

    if (this.errorTimeout) clearTimeout(this.errorTimeout);

    this.errorTimeout = setTimeout(() => {
      this.clearError();
    }, 1700);
  }

  clearError() {
    if (!this.input) return;

    this.input.classList.remove('is-invalid');

    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
      this.errorTimeout = null;
    }
  }
}

customElements.define('cart-discount-code', CartDiscountCode);